export default class Region {
  id: number
  name: string
  code: string

  constructor(props: any) {
    this.id = props.id
    this.name = props.name
    this.code = props.code
  }
}
